'use client';

import React from 'react';
import CustomLink from 'components/shared/CustomLink';
import { useTranslations } from 'next-intl';

import { LinkWithArrow } from './LinkWithArrow';
import listIcon from '../../assets/images/list-icon.svg';
import { useBuyNowLink } from './useBuyNowLink';
import styles from './SubscriptionCTA.module.css';

export const SubscriptionCTA = ({ className }: { className?: string }) => {
  const link = useBuyNowLink();
  const t = useTranslations('common');
  const rootClassName = [styles.root, 'u-grid', className]
    .filter(Boolean)
    .join(' ');
  return (
    <CustomLink href={link} className={rootClassName}>
      <div>
        <div>
          <h3>
            {t('subscriptionCta.heading.inEvery')}
            <br />
            {t('subscriptionCta.heading.ultrahumanSubscription')}
          </h3>
        </div>
        <div>
          <LinkWithArrow as="span" className="subscriptionCtaBuyNow">
            {t('subscriptionCta.link.buyNow')}
          </LinkWithArrow>
        </div>
        <div>
          <ul
            style={
              { ['--list-icon' as any]: `url(${listIcon.src})` } as React.CSSProperties
            }
          >
            <li>{t('subscriptionCta.item.sleepSessions')}</li>
            <li>{t('subscriptionCta.item.guidedNutritionPlan')}</li>
            <li>{t('subscriptionCta.item.brainMusicCollection')}</li>
            <li>{t('subscriptionCta.item.appleBiofeedback')}</li>
          </ul>
        </div>
      </div>
    </CustomLink>
  );
};
